export default "__VITE_ASSET__c5b70899__"